import { render } from "./RiTreeClose.vue?vue&type=template&id=38fe82fd"
import script from "./RiTreeClose.vue?vue&type=script&lang=js"
export * from "./RiTreeClose.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiTreeClose.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "38fe82fd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('38fe82fd', __exports__)) {
    api.reload('38fe82fd', __exports__)
  }
  
  module.hot.accept("./RiTreeClose.vue?vue&type=template&id=38fe82fd", () => {
    api.rerender('38fe82fd', render)
  })

}


export default __exports__